import DOMPurify from 'dompurify';

// Every place that renders stored rich text (Quill output) goes through safeHtml().
// Only basic formatting, links and images get through: no scripts, event handlers, forms or inline styles.
// Classes are limited to Quill's own `ql-*` ones so a post can't borrow the app's styling to cover the screen.
const CONFIG = {
    ALLOWED_TAGS: ['p', 'br', 'hr', 'div', 'span', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'blockquote',
        'pre', 'code', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'img'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel', 'class'],
    ALLOW_DATA_ATTR: false,
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute && node.hasAttribute('class')) {
        const kept = node.getAttribute('class').split(/\s+/).filter(c => /^ql-[a-z0-9-]+$/.test(c));
        if (kept.length) node.setAttribute('class', kept.join(' '));
        else node.removeAttribute('class');
    }
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export const safeHtml = (html) => DOMPurify.sanitize(typeof html === 'string' ? html : '', CONFIG);

// For plain text that is being placed inside an HTML string (e.g. Leaflet popups).
export const escapeHtml = (text) => String(text ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
